(function () {
  "use strict";

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var value = (Math.round(cents) / 100).toFixed(2);
    var withComma = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (!format) return "$" + withComma;
    if (format.indexOf("{{amount}}") !== -1) return format.replace("{{amount}}", withComma);
    if (format.indexOf("{{amount_no_decimals}}") !== -1) {
      return format.replace("{{amount_no_decimals}}", String(Math.round(cents / 100)));
    }
    if (format.indexOf("{{amount_with_comma_separator}}") !== -1) {
      return format.replace("{{amount_with_comma_separator}}", value.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."));
    }
    return format.replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function salePrice(cents, pct) {
    return Math.round(cents * (100 - pct) / 100);
  }

  function isTitleOnly(opt) {
    return opt && opt.name === "Title" && (opt.values || []).length <= 1;
  }

  function findVariant(item, selected) {
    var variants = item.variants || [];
    return variants.find(function (v) {
      return (item.options || []).every(function (opt, i) {
        if (isTitleOnly(opt)) return true;
        var wanted = selected[opt.name];
        if (!wanted) return true;
        return v.options[i] === wanted;
      });
    }) || null;
  }

  function firstAvailableVariant(item) {
    var variants = item.variants || [];
    return variants.find(function (v) { return v.available; }) || variants[0] || null;
  }

  function optionImage(item, optName, value) {
    var idx = item.options.findIndex(function (o) { return o.name === optName; });
    if (idx === -1) return "";
    var v = item.variants.find(function (vr) { return vr.options[idx] === value && vr.image; });
    return v ? v.image : (item.featuredImage || "");
  }

  function valueIsAvailable(item, optName, value, selected) {
    var idx = (item.options || []).findIndex(function (o) { return o.name === optName; });
    if (idx === -1) return false;
    return (item.variants || []).some(function (v) {
      if (!v.available) return false;
      if (v.options[idx] !== value) return false;
      return (item.options || []).every(function (opt, i) {
        if (i === idx || isTitleOnly(opt)) return true;
        var wanted = selected[opt.name];
        if (!wanted) return true;
        return v.options[i] === wanted;
      });
    });
  }

  // In stock in at least one combination, whatever else is selected
  function valueInStock(item, optName, value) {
    var idx = (item.options || []).findIndex(function (o) { return o.name === optName; });
    if (idx === -1) return false;
    return (item.variants || []).some(function (v) { return v.available && v.options[idx] === value; });
  }

  // Available variant with this value that changes the other picks least,
  // preferring the nearest value (e.g. the next size up or down)
  function closestVariant(item, optName, value, selected) {
    var options = item.options || [];
    var idx = options.findIndex(function (o) { return o.name === optName; });
    var best = null;
    var bestScore = Infinity;
    (item.variants || []).forEach(function (v) {
      if (!v.available || v.options[idx] !== value) return;
      var score = 0;
      options.forEach(function (opt, i) {
        if (i === idx || isTitleOnly(opt)) return;
        var wanted = selected[opt.name];
        if (!wanted || v.options[i] === wanted) return;
        var values = opt.values || [];
        score += 1 + Math.abs(values.indexOf(v.options[i]) - values.indexOf(wanted)) / 100;
      });
      if (score < bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  // Pick a value. If that combination isn't in stock, move the other
  // options to the closest one that is, so every in-stock value is one click away.
  function selectValue(item, selected, optName, value) {
    selected[optName] = value;
    var current = findVariant(item, selected);
    if (current && current.available) return;
    var v = closestVariant(item, optName, value, selected);
    if (!v) return;
    (item.options || []).forEach(function (opt, i) {
      if (!isTitleOnly(opt)) selected[opt.name] = v.options[i];
    });
  }

  // e.g. "blue / 7m" for the picks other than optName
  function otherPicks(item, selected, optName) {
    return (item.options || []).filter(function (opt) {
      return opt.name !== optName && !isTitleOnly(opt) && selected[opt.name];
    }).map(function (opt) { return selected[opt.name]; }).join(" / ");
  }

  function KitBuilder(root) {
    this.root = root;
    var jsonEl = qs(root, "#KitBuilderJSON");
    if (!jsonEl) return;
    try { this.data = JSON.parse(jsonEl.textContent); }
    catch (e) { return; }
    if (!this.data.items) this.data.items = [];
    this.discount = Number(this.data.discountPercent) || 0;
    this.moneyFormat = this.data.moneyFormat || "${{amount}}";
        this.selected = {};
    this.data.items.forEach(function (item) {
      this.selected[item.id] = {};
      this.ensureSelection(item);
    }, this);
    this.bind();
    this.syncAll();
  }

  KitBuilder.prototype.ensureSelection = function (item) {
    if (!item) return;
    if (!this.selected[item.id]) this.selected[item.id] = {};
    var sel = this.selected[item.id];
    var needs = (item.options || []).some(function (opt) {
      if (isTitleOnly(opt)) return false;
      return !sel[opt.name];
    });
    if (!needs) {
      var current = findVariant(item, sel);
      if (current && current.available) return;
    }
    var v = firstAvailableVariant(item);
    if (!v) return;
    (item.options || []).forEach(function (opt, i) {
      if (isTitleOnly(opt)) return;
      if (v.options[i] != null) sel[opt.name] = v.options[i];
    });
  };

  KitBuilder.prototype.cardForIndex = function (index) {
    return qs(this.root, '[data-kit-card][data-kit-index="' + index + '"]');
  };

  KitBuilder.prototype.bind = function () {
    var self = this;
    qsa(this.root, "[data-kit-item]").forEach(function (row) {
      row.addEventListener("click", function () {
        self.toggle(Number(row.getAttribute("data-kit-index")));
      });
    });
    qsa(this.root, "[data-kit-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var stage = qs(self.root, "[data-kit-stage]");
        var src = thumb.getAttribute("data-src");
        if (stage && src) stage.src = src;
        qsa(self.root, "[data-kit-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
    var form = qs(this.root, "[data-kit-form]");
    if (form) form.addEventListener("submit", function (e) { self.submit(e); });
  };

  KitBuilder.prototype.toggle = function (index) {
    var card = this.cardForIndex(index);
    if (!card) return;
    if (card.classList.contains("is-open")) {
      this.close(index);
      return;
    }
    this.open(index);
  };

  KitBuilder.prototype.close = function (index) {
    var card = this.cardForIndex(index);
    if (!card) return;
    card.classList.remove("is-open");
    var panel = qs(card, "[data-kit-panel]");
    var btn = qs(card, "[data-kit-item]");
    if (panel) panel.hidden = true;
    if (btn) btn.setAttribute("aria-expanded", "false");
    this.syncAll();
  };

  KitBuilder.prototype.open = function (index) {
    var item = this.data.items[index];
    if (!item) return;
    this.ensureSelection(item);
    var card = this.cardForIndex(index);
    if (!card) return;
    card.classList.add("is-open");
    var panel = qs(card, "[data-kit-panel]");
    var btn = qs(card, "[data-kit-item]");
    if (panel) panel.hidden = false;
    if (btn) btn.setAttribute("aria-expanded", "true");
    this.showInGallery(item);
    this.renderPanel(index);
    this.syncAll();
  };

  // Show the opened item's featured image in the product gallery.
  // Clicking its thumbnail drives both the desktop viewer and the mobile slider.
  KitBuilder.prototype.showInGallery = function (item) {
    var product = this.root.closest(".product--outer");
    if (!product || !item.featuredMediaId) return;
    var thumb = qs(product, '[data-gallery-thumbnail][data-media="' + item.featuredMediaId + '"]');
    if (thumb) thumb.click();
  };

  KitBuilder.prototype.currentVariant = function (item) {
    if (!item) return null;
    return findVariant(item, this.selected[item.id] || {});
  };

  KitBuilder.prototype.isConfigured = function (item) {
    var sel = this.selected[item.id] || {};
    return (item.options || []).every(function (opt) {
      if (isTitleOnly(opt)) return true;
      if (!(opt.values || []).length) return true;
      return !!sel[opt.name];
    });
  };

  KitBuilder.prototype.renderPanel = function (index) {
    var item = this.data.items[index];
    var card = this.cardForIndex(index);
    if (!item || !card) return;
    var variant = this.currentVariant(item);
    var cents = variant ? variant.price : item.price;
    var sale = salePrice(cents, this.discount);
    var saleEl = qs(card, "[data-panel-sale]");
    var cmpEl = qs(card, "[data-panel-compare]");
    var pct = qs(card, "[data-panel-pct]");
    if (saleEl) saleEl.textContent = formatMoney(sale, this.moneyFormat);
    if (cmpEl) cmpEl.textContent = formatMoney(cents, this.moneyFormat);
    if (pct) pct.textContent = this.discount ? ("-" + this.discount + "%") : "";
    this.renderOptions(item, card);
  };

  KitBuilder.prototype.renderOptions = function (item, card) {
    var mount = qs(card, "[data-kit-options]");
    if (!mount) return;
    mount.innerHTML = "";
    var self = this;
    var sel = this.selected[item.id] || {};
    var meaningful = (item.options || []).filter(function (opt) {
      return opt.values && opt.values.length && !isTitleOnly(opt);
    });
    if (!meaningful.length) {
      mount.innerHTML = '<p class="kit-builder__item-sub">No size options — this item is ready.</p>';
      return;
    }
    meaningful.forEach(function (opt) {
      var wrap = document.createElement("div");
      wrap.className = "kit-builder__opt";
      var label = document.createElement("p");
      label.className = "kit-builder__opt-label";
      var current = sel[opt.name] || "";
      label.textContent = "Select " + opt.name + (current ? ("  " + current) : "");
      if (opt.sizeChart) {
        var a = document.createElement("a");
        a.className = "kit-builder__size-chart";
        a.href = opt.sizeChart;
        a.target = "_blank";
        a.rel = "noopener";
        a.textContent = "Size chart";
        label.appendChild(a);
      }
      wrap.appendChild(label);
      var isColor = /colou?r/i.test(opt.name);
      var box = document.createElement("div");
      box.className = isColor ? "kit-builder__swatches" : "kit-builder__pills";
      opt.values.forEach(function (val) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = isColor ? "kit-builder__swatch" : "kit-builder__pill";
        // Sold out everywhere: disabled. Not in the current picks: crossed out
        // but clickable (selectValue moves the other picks).
        if (!valueInStock(item, opt.name, val)) {
          btn.disabled = true;
          btn.classList.add("is-soldout");
          btn.title = val + " – sold out";
        } else if (!valueIsAvailable(item, opt.name, val, sel)) {
          btn.classList.add("is-unmatched");
          btn.title = val + " – not available in " + otherPicks(item, sel, opt.name);
        }
        if (btn.title) btn.setAttribute("aria-label", btn.title);
        if (current === val) btn.classList.add("is-selected");
        var imgUrl = isColor ? optionImage(item, opt.name, val) : "";
        if (isColor && imgUrl) {
          var im = document.createElement("img");
          im.src = imgUrl;
          im.alt = val;
          btn.appendChild(im);
        } else {
          btn.textContent = val;
        }
        btn.addEventListener("click", function (e) {
          e.stopPropagation();
          if (btn.disabled) return;
          selectValue(item, self.selected[item.id], opt.name, val);
          self.syncAll();
          self.renderPanel(Number(card.getAttribute("data-kit-index")));
        });
        box.appendChild(btn);
      });
      wrap.appendChild(box);
      mount.appendChild(wrap);
    });
  };

  KitBuilder.prototype.syncAll = function () {
    var self = this;
    var totalSale = 0;
    var totalCmp = 0;
    var configured = 0;
    var soldOut = [];
    this.data.items.forEach(function (item, index) {
      var variant = self.currentVariant(item);
      var itemSoldOut = !(item.variants || []).some(function (v) { return v.available; });
      if (itemSoldOut) soldOut.push(item.title);
      var card = self.cardForIndex(index) || qs(self.root, '[data-kit-item="' + item.id + '"]');
      var row = card && card.classList.contains("kit-builder__card") ? qs(card, "[data-kit-item]") : card;
      if (!row) return;
      var cents = variant ? variant.price : item.price;
      var sale = salePrice(cents, self.discount);
      totalSale += sale;
      totalCmp += cents;
      var saleEl = qs(row, "[data-item-sale]") || (card && qs(card, "[data-item-sale]"));
      var cmpEl = qs(row, "[data-item-compare]") || (card && qs(card, "[data-item-compare]"));
      if (saleEl) saleEl.textContent = formatMoney(sale, self.moneyFormat);
      if (cmpEl) cmpEl.textContent = formatMoney(cents, self.moneyFormat);
      var img = qs(row, "[data-item-img]") || (card && qs(card, "[data-item-img]"));
      if (img && variant && variant.image) img.src = variant.image;
      var optsEl = qs(row, "[data-item-opts]") || (card && qs(card, "[data-item-opts]"));
      var parts = [];
      Object.keys(self.selected[item.id] || {}).forEach(function (k) {
        if (k === "Title") return;
        parts.push(self.selected[item.id][k]);
      });
      var ready = self.isConfigured(item) && variant && variant.available;
      if (optsEl) optsEl.textContent = itemSoldOut ? "Sold out" : (parts.length ? parts.join(" / ") : "");
      if (card && card.classList) {
        card.classList.toggle("is-configured", !!ready);
        card.classList.toggle("is-unavailable", !!(variant && !variant.available));
        card.classList.toggle("is-soldout", itemSoldOut);
      }
      row.classList.toggle("is-configured", !!ready);
      row.classList.toggle("is-unavailable", !!(variant && !variant.available));
      if (ready) configured += 1;
    });
    var headSale = qs(this.root, "[data-kit-total-sale]");
    var headCmp = qs(this.root, "[data-kit-total-compare]");
    if (headSale) headSale.textContent = formatMoney(totalSale, this.moneyFormat);
    if (headCmp) headCmp.textContent = formatMoney(totalCmp, this.moneyFormat);
    var cta = qs(this.root, "[data-kit-cta]");
    var n = this.data.items.length;
    var allReady = configured === n && n > 0 && !soldOut.length;
    if (cta) {
      cta.disabled = !allReady;
      cta.classList.toggle("is-soldout", soldOut.length > 0);
      var label = qs(cta, "[data-kit-cta-label]");
      var prog = qs(cta, "[data-kit-cta-progress]");
      // An item with nothing in stock can't be fixed by choosing options, so say so
      if (soldOut.length) {
        if (label) label.textContent = "Out of stock";
        if (prog) prog.textContent = soldOut.length === 1 ? soldOut[0] + " is sold out" : soldOut.length + " items are sold out";
      } else {
        if (label) label.textContent = allReady ? (this.data.addLabel || "Add to cart") : (this.data.selectLabel || "Select all items");
        if (prog) prog.textContent = allReady ? "" : (configured + "/" + n);
      }
    }
    this.renderShopPay(allReady);
  };

  // Shop Pay for the whole kit, e.g. variants="4501:1,4502:1".
  // Rebuilt on each change because the component reads its variants once.
  KitBuilder.prototype.renderShopPay = function (allReady) {
    var mount = qs(this.root, "[data-kit-shop-pay]");
    if (!mount) return;

    var self = this;
    var variants = allReady ? this.data.items.map(function (item) {
      return self.currentVariant(item).id + ":1";
    }).join(",") : "";

    if (!variants) {
      mount.hidden = true;
      mount.innerHTML = "";
      this.shopPayVariants = "";
      return;
    }

    mount.hidden = false;
    if (variants === this.shopPayVariants) return;

    this.shopPayVariants = variants;
    var button = document.createElement("shop-pay-button");
    button.setAttribute("store-url", this.data.storeUrl);
    button.setAttribute("variants", variants);
    mount.innerHTML = "";
    mount.appendChild(button);
  };

  KitBuilder.prototype.submit = function (e) {
    e.preventDefault();
    var self = this;
    this.data.items.forEach(function (item) { self.ensureSelection(item); });
    this.syncAll();
    var items = [];
    var blocked = false;
    this.data.items.forEach(function (item) {
      var v = self.currentVariant(item);
      if (!v || !v.available || !self.isConfigured(item)) blocked = true;
      else items.push({
        id: v.id,
        quantity: 1,
        properties: {
          _kit: self.data.parentHandle,
          _kit_item: item.handle,
          _kit_discount: String(self.discount || 0)
        }
      });
    });
    if (blocked || items.length !== this.data.items.length) return;
    var cta = qs(this.root, "[data-kit-cta]");
    if (cta) cta.disabled = true;
    if (this.data.demo) {
      var demo = document.getElementById("demo-cart");
      if (demo) demo.hidden = false;
      if (cta) cta.disabled = false;
      return;
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart add failed");
      var code = self.data.discountCode;
      if (code) window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
      else window.location.href = "/cart";
    }).catch(function () {
      if (cta) cta.disabled = false;
      alert("Could not add this kit to the cart. Please try again.");
    });
  };

  function boot() {
    qsa(document, "[data-kit-builder]").forEach(function (el) { new KitBuilder(el); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
